import axios from 'axios';

export default async function geoCoder(searchString) {
  const params = {
    'X-Map-Viewport': '116.3658,39.9098,116.4095,39.9197',
    'X-Political-View': 'USA',
    app_id: process.env.VUE_APP_HERE_APP_ID,
    app_code: process.env.VUE_APP_HERE_APP_CODE,
    q: searchString,
    result_types: 'address,place,category,chain',
    size: 5,
    tf: 'plain',
    withExperiments: 'PBAPI_3292_autosuggest_cuisines%3Dtrue',
  };
  const serializedParams = Object
    .entries(params)
    .map(([key, val]) => `${key}=${val}`).join('&');
  const url = `https://places.cit.api.here.com/places/v1/autosuggest?${serializedParams}`;
  const places = await axios.get(url);
  // replace the \r and \n from vicinity
  return places.data.results.map(({ id, title, vicinity }) => ({
    id,
    title,
    vicinity: vicinity ? vicinity.replace(/(\r\n|\n|\r)/gm, ' ') : '',
  }));
}
